const CANHCAM_APP = {"ACTIVE_FIXED_HEADER": true,"HEADER_TRANPARENT": false,"ACTIVE_HEADER_POSITION": 1,"ACTIVE_PADDING_MAIN": true,"ACTIVE_VALIDATOR": true,"ACTIVE_SELECT": true,"ACTIVE_FIXED_FOOTER": true,"ACTIVE_LIST_TO_SELECT": true,"DISPLAY_FOOTER": 600,"ACTIVE_RESPONSIVE": true,"ACTIVE_BACKTOTOP": true,"DISPLAY_BACKTOTOP": 100,"CHANGE_GRID": 991,"CHANGE_GRID_SM": 767,"DEV_MODE": false,"DEV_MODE_GIRD_FULL": false}
function backToTop() {
    if ($('#back-to-top').length) {
        var backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > CANHCAM_APP.DISPLAY_BACKTOTOP) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }
        };
        backToTop();
        $(window).on('scroll', function() {
            backToTop();
        });
        $('#back-to-top').on('click', function(e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

$(document).ready(function() {
    $('#back-to-top i').removeClass('fa-angle-up').addClass('fa-arrow-up')
    if (CANHCAM_APP.ACTIVE_BACKTOTOP) {
        backToTop()
    }
});
function CanhCamResponsive() {
	// Set BG Mask
	$('[bg-mask]').each(function () {
		var bgimg = $(this).attr('bg-mask');
		$(this).css({
			"mask-image": "url(" + bgimg + ")",
			"mask-position": "center center",
			"mask-repeat": "no-repeat",
			"-webkit-mask-image": "url(" + bgimg + ")",
			"-webkit-mask-position": "center center",
			"-webkit-mask-repeat": "no-repeat"
		});
	})
	// Set BG Resposive
	$('[bg-img]').each(function () {
		var bgimg = $(this).attr('bg-img');
		var pos = $(this).attr('bg-pos');
		var size = $(this).attr('bg-size');
		if (pos && pos.length > 0) {
			$(this).css({
				"background-position": pos
			});
		} else {
			$(this).css({
				"background-position": "center center"
			});
		}
		if (size && size.length > 0) {
			$(this).css({
				"background-size": size
			});
		} else {
			$(this).css({
				"background-size": "cover"
			});
		}
		$(this).css({
			"background-image": "url(" + bgimg + ")"
		});
	});

	$('[bg-img-responsive]').each(function () {
		var bgimg = $(this).attr('bg-img-responsive');
		var bgimgsm = $(this).attr('bg-img-responsive-sm');
		var bgimgxs = $(this).attr('bg-img-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).css({
				"background-image": "url(" + bgimg + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).css({
				"background-image": "url(" + bgimgsm + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else {
			$(this).css({
				"background-image": "url(" + bgimgxs + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		}
	});

	$('[img-src-responsive]').each(function () {
		var bgimg2 = $(this).attr('img-src-responsive');
		var bgimg2sm = $(this).attr('img-src-responsive-sm');
		var bgimg2xs = $(this).attr('img-src-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).attr("src", "" + bgimg2 + "");
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).attr("src", "" + bgimg2sm + "");
		} else {
			$(this).attr("src", "" + bgimg2xs + "");
		}
	});

};

$(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})

$(window).resize(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})

$(function() {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover({
        trigger: 'focus'
    })
})
// Thêm [dropdown-type="hover"] vào thẻ a để bật tính năng hover open dropdown
if ($(window).width() > CANHCAM_APP.CHANGE_GRID) {
	$('.dropdown').on('mouseenter mouseleave', function () {
		var ___d = $(this).find('[dropdown-type="hover"]').parents('.dropdown')
		if (___d && ___d.length > 0) {
			$(this).find('[dropdown-type="hover"]').removeAttr('data-toggle')
			setTimeout(function () {
				___d[___d.is(':hover') ? 'addClass' : 'removeClass']('show');
				___d.is(':hover') ? ___d.find('.dropdown-menu').show() : ___d.find('.dropdown-menu').hide()
			}, 10);
		}
	})
} else {
	$('.dropdown').each(function () {
		$(this).addClass('show')
		$(this).find('.dropdown-menu').show()
	})
}



$('[data-count-id]').each(function() {
	window[$(this)[0].dataset.countId] = false
})

function countUpCanhCam() {

	$('[data-count]').each(function () {
		let elm = $(this).offset().top
		let docH = $(window).height()
		let docS = $(window).scrollTop()
		let padingTop = 0
		if ($(this).attr('data-top') && $(this).attr('data-top').length) {
			padingTop = parseInt($(this).attr('data-top'));
		}
		let result = (elm + padingTop) - (docH + docS)
		let countId = $(this)[0].dataset.countId
		let run = window[countId]

		if (result <= 0 && !run) {
			let $this = $(this),
				countTo = $this.attr('data-count'),
				durationTo = parseInt($this.attr('data-duration')),
				textAfterCount = $this.attr('data-text-after-count')
			$({ countNum: $this.text() }).animate({
				countNum: countTo
			}, {
					duration: durationTo,
					easing: 'linear',
					step: function () {
						$this.text(Math.floor(this.countNum));
					},
					complete: function () {
						$this.text(this.countNum);
						if (textAfterCount) {
							$this.text(textAfterCount)
						}
						window[countId] = true
					}
				});
		}
	});
}

$(document).ready(function () {
	countUpCanhCam()

});

$(window).scroll(function () {
	countUpCanhCam()

});

$(window).resize(function () {
	countUpCanhCam()
})


function setFooter() {
    var bodyHeight = $("body").outerHeight(),
        headerHeight = $("header").outerHeight(),
        footerHeight = $("footer").outerHeight(),
        mainHeight = $("main").outerHeight(),
        curentHeight = mainHeight + headerHeight + footerHeight,
        curentfixedHeight = mainHeight + footerHeight,
        newHeight = bodyHeight - (headerHeight + footerHeight),
        newfixedHeight = bodyHeight - footerHeight;
    if ($(window).width() > CANHCAM_APP.DISPLAY_FOOTER) {
        if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
            $("main").css('min-height', newfixedHeight + 'px')
        } else {
            if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
                $("main").css('min-height', newHeight + 'px')
            } else {
                $("main").css('min-height', newfixedHeight + 'px')
            }
        }
    } else {
        $("main").css('min-height', 'initial')
    }
}

$(document).ready(function() {
    if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
        setFooter()
    }
});

$(window).resize(function() {
    if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
        setFooter()
    }
})
function setHeader(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").addClass('active');
	} else {
		$("header").removeClass('active');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		$("header").addClass('fixedheader');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeader($(window).scrollTop());
		}
	} else {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
	if ($("header").hasClass("fixedheader")) {
		$("main").addClass('main-fixedheader');
	}
});

// Fixed Header
$(window).scroll(function () {
	setHeader($(document).scrollTop());
});
// Fixed Header
$(window).resize(function () {
	if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
});


function setMain() {
    var
		headerHeight = $("header").outerHeight();
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
				$("main").css('padding-top', headerHeight + 'px')
		} else {
			if (!CANHCAM_APP.ACTIVE_PADDING_MAIN) {
				$("main").css('padding-top', '0px')
			} else {
				if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
					$("main").css('padding-top', 'initial')
				} else {
					$("main").css('padding-top', headerHeight + 'px')
				}
			}
		}
}

$(document).ready(function() {
    setMain()
});

$(window).resize(function() {
    setMain()
})

function setHeaderTranparent(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").removeClass('has-tranparent');
	} else {
		$("header").addClass('has-tranparent');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		$("header").addClass('has-tranparent');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeaderTranparent($(window).scrollTop());
		}
	}

});

// Tranparent Header
$(window).scroll(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		setHeaderTranparent($(document).scrollTop());
	}
});


function canhcamID(e) {
	var text = "";
	var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	for (var i = 0; i < e; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	return text;
}

function b64EncodeUnicode(str) {
	return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
		function toSolidBytes(match, p1) {
			return String.fromCharCode('0x' + p1);
		}));
}

function b64DecodeUnicode(str) {
	return decodeURIComponent(atob(str).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

// Copyright 2014-2017 The Bootstrap Authors
// Copyright 2014-2017 Twitter, Inc.
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

$(function() {
    var nua = navigator.userAgent
    var isAndroid = (nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1)
    if (isAndroid) {
        $('select.form-control').removeClass('form-control').css('width', '100%')
    }
})
function listToSelect() {
	$('[data-select]').each(function () {
		var list = $(this), select = $(document.createElement('select')).insertBefore($(this).hide());
		select.addClass('custom-select').attr('data-select-show', '');
		$('>li a', this).each(function () {
			var option = $(document.createElement('option'))
				.appendTo(select)
				.val(this.href)
				.html($(this).html())
		});
		list.hide().removeAttr('data-select').attr('data-select-changed', '');
		select.on('change', function () {
			var url = $(this).val();
			if (url) {
				window.location = url;
			}
			return false;
		});
	});
}

function selectChangeToList() {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		if ($(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$('[data-select-changed]').each(function () {
				$(this).show().removeAttr('data-select-changed').attr('data-select', '');
			})
			$('[data-select-show]').remove()
		} else {
			listToSelect()
		}
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID_SM) {
			listToSelect()
		}
	}
});

$(window).resize(function () {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		selectChangeToList()
	}
});


console.log('%cCANHCAM', 'font-size:100px;color:#ff451a;text-shadow:0 1px 0 #f73936,0 2px 0 #f73936 ,0 3px 0 #f73936 ,0 4px 0 #f73936 ,0 5px 0 #f73936 ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);')
console.log('%c CANHCAM ' + '%c - The best Web Solutions Provider', 'border-radius: 2px; padding: 3px; background: #ff451a; color: #FFF', 'color: #ff451a');
console.warn("CANHCAM warning: This is a browser feature intended for developers. If someone told you to copy and paste something here to enable a CANHCAM feature or 'hack' someone's account, it is a scam and will give them access to your CANHCAM account.");
document.onkeyup = function (a) { if ((a = a || window.event).altKey && a.ctrlKey && a.shiftKey && 13 == a.which) return $("body"), alert(b64DecodeUnicode("VGhp4bq/dCBr4bq/IHbDoCBs4bqtcCB0csOsbmggYuG7n2kgQ8O0bmcgVHkgQ8OhbmggQ2FtLiBU4bqldCBj4bqjIHF1eeG7gW4gxJHGsOG7o2MgYuG6o28gaOG7mS4KCkRlc2lnbmVkIGFuZCBkZXZlbG9wZWQgYnkgQ2FuaCBDYW0uIEFsbCByaWdodHMgcmVzZXJ2ZWQuCgpodHRwczovL3d3dy5jYW5oY2FtLnZuLw==")), !1 };



function canhCamStickyComtent() {

	$('[data-fix]').each(function () {
		$(this).css({
			"z-index": '500'
		})
		if ($(this).attr('data-top') && $(this).attr('data-top').length) {
			$(this).css({
				"top": $(this).attr('data-top')
			})
		}
		if ($(this).attr('data-left') && $(this).attr('data-left').length) {
			$(this).css({
				"left": $(this).attr('data-left')
			})
		}
		if ($(this).attr('data-bottom') && $(this).attr('data-bottom').length) {
			$(this).css({
				"bottom": $(this).attr('data-bottom')
			})
		}
		if ($(this).attr('data-right') && $(this).attr('data-right').length) {
			$(this).css({
				"right": $(this).attr('data-right')
			})
		}

		var toFix = 0
		var typeFix = 'fixed'
		var changeFix = 'static'

		if ($(this).attr('data-fix') && $(this).attr('data-fix').length) {
			toFix = parseInt($(this).attr('data-fix'))
		}
		if ($(this).attr('data-fix-type') && $(this).attr('data-fix-type').length) {
			typeFix = $(this).attr('data-fix-type')
		}
		if ($(this).attr('data-fix-change') && $(this).attr('data-fix-change').length) {
			changeFix = $(this).attr('data-fix-change')
		}

		$(this).css({
			"position": typeFix
		})

		var scrollTop = $(window).scrollTop();
		var elementOffset = $(this).offset().top;
		var currentElementOffset = (elementOffset - scrollTop);
		if (currentElementOffset <= toFix) {
			$(this).css({
				"position": changeFix,
				"top": toFix + 'px'
			})
		}

	});
}


$(document).ready(function () {
	canhCamStickyComtent()
});

$(window).scroll(function () {
	canhCamStickyComtent()
});

$(window).resize(function () {
	canhCamStickyComtent()
})


function CCHeader12() {
	$('.canhcam-header-12 #demoResAllInOneMenu').kResponsiveMenu({
		animationSpeed: 'fast', // slow, fast, 200
		resizeWidth: 'lg', // 'xs', 'sm', 'md', 'lg', 'xl', 480,
		menuType: 'horizontal', // horizontal, vertical
		menuPush: 'right', // right, left
		menuPushPosition: 'fixed', // absolute
		menuPushWidth: '300px', // px, %, rem
		menuBackDrop: true, // px, %, rem
	})
};

function CCHeader7() {
	$('.canhcam-header-12 .btnsearch .btn').on("click", function () {
		$('.canhcam-header-12 .form-inline').toggleClass('active')
		$('.canhcam-header-12 .btnsearch').toggleClass('active')
	});
};
$(document).ready(function () {
	CCHeader12();
	CCHeader7();
	$(".canhcam-header-12 .language .dropdown .dropdown-menu").removeAttr("style")

	const loginLength = $('.login.col').children().length
	if($(window).outerWidth() >= 992) {
		if (loginLength === 1) {
			$('.login').removeClass().addClass('login').addClass('col').addClass('login-nologin')
			$('.login.col li').prepend('<em class="mdi mdi-account"></em>')
		} else {
			$('.login').removeClass().addClass('login').addClass('col').addClass('login-logined')
			$('.login.col li:first').prepend('<em class="mdi mdi-account-outline"></em>')
		}
	} else {
		if (loginLength === 2) {
			$('.login').removeClass().addClass('login').addClass('col').addClass('login-nologin')
		} else {
			$('.login').removeClass().addClass('login').addClass('col').addClass('login-logined')
			$('.login.col li:first').prepend('<em class="mdi mdi-account-outline"></em>')
		}
	}
});
// Fixed Header
$(window).scroll(function () {
});

$(window).resize(function () {
})

$(function() {
	if ($('.canhcam-slider-1 .owl-carousel').length) {
		$('.canhcam-slider-1 .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			center: false,
			padding: 0,
			margin: 0,
			navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
			nav: false,
			dots: false,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			callbacks: true,
			smartSpeed: 3000,
			// mouseDrag: false,
			// touchDrag: false,
			// pullDrag: false,
			// freeDrag: false,
			responsive: {
				768: {
					nav: false
				}
			}
		});
	}

});

$(document).ready(function(){
	// $('.canhcam-home-1 .home-lists .Module-354 .ModuleContent').addClass('row')
})




function scrollNav(){
	$('.canhcam-nav-1 ul.nav ').hide();
	$('.canhcam-nav-1 .trigger-btn').on('click', function() {
		if ($('.canhcam-nav-1 nav ').is(':hidden') === true) {
			$('.canhcam-nav-1 nav ').slideDown('slow')
			$(this).addClass('active')
		} else {
			$('.canhcam-nav-1 nav ').slideUp('slow')
			$(this).removeClass('active')
		}

	})
	$('.canhcam-nav-1 ul.nav').removeAttr( "style" )
}
$(document).ready(function(){
	scrollNav()
})
$(document).ready(function () {
	$(".canhcam-nav-2 .custom-select").each(function () {
		var classes = $(this).attr("class"),
			id = $(this).attr("id"),
			name = $(this).attr("name");
		var template = '<div class="' + classes + '">';
		template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
		template += '<div class="custom-options">';
		$(this).find("option").each(function () {
			template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
		});
		template += '</div></div>';

		$(this).wrap('<div class="custom-select-wrapper"></div>');
		$(this).hide();
		$(this).after(template);
	});
	$(".canhcam-nav-2 .custom-select-wrapper .custom-option:first-of-type").hover(function () {
		$(this).parents(".custom-options").addClass("option-hover");
	}, function () {
		$(this).parents(".custom-options").removeClass("option-hover");
	});
	$(".canhcam-nav-2 .custom-select-wrapper .custom-select-trigger").on("click change", function () {
		$('html').one('click', function () {
			$(".canhcam-nav-2 .custom-select").removeClass("opened");
		});
		
		$(this).parents(".canhcam-nav-2 .custom-select").toggleClass("opened");
		event.stopPropagation();
	});
	$(".canhcam-nav-2 .custom-select-wrapper .custom-option").on("click", function (e) {
		$(this).parents(".canhcam-nav-2 .custom-select-wrapper").find("select").val($(this).data("value"));
		$(this).parents(".custom-options").find(".custom-option").removeClass("selection");
		$(this).addClass("selection");
		$(this).parents(".custom-select").removeClass("opened");
		$(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
		$(e.currentTarget).parent().parent().prev().trigger('change');
		
	});
});

// $(document).ready(function(){
// 	if ($(window) < 992) {
// 		$('.canhcam-nav-3 .nav-list ul.nav').owlCarousel({
// 			autoWidth: true
// 		})
// 	}

// })

$(document).ready(function(){
	$(".canhcam-document-1 .document-lists .item .hidden").lightGallery({
		thumbnail:true
	});

	$(".canhcam-document-1 .document-lists .item").each(function() {
		$(this).click(function(){
			$(this).find('.hidden a:first-child').trigger('click')
		})
	});
})


$(document).ready(function () {
	if ($('.canhcam-support1-1 .item ul li a').attr('href')) {
		$('.canhcam-support1-1 .item ul li a').css({
			'display': 'inline-block'
		})
	} else {
		$('.canhcam-support1-1 .item ul li a').css({
			'display': 'none'
		})
	}
})

$(document).ready(function () {
	$('.canhcam-support1-2 .item select').addClass("custom-select");
	let selectPlaceholder = $('.canhcam-support1-2 .item .company select option:first , .canhcam-support1-2 .item .country select option:first');
	selectPlaceholder.attr('disabled', true)
	selectPlaceholder.attr('selected', true)
	try {
		const contactFormSupportTextareaParent = $('.liena-support-contactform-textarea').parent()
		contactFormSupportTextareaParent.append($('.canhcam-support1-2 .frm-btn-submit').parent().parent()[0].outerHTML)
		$('.canhcam-support1-2 .frm-btn-submit').parent().parent()[1].outerHTML = null
	} catch (error) {

	}
});

$(document).ready(function(){
	$('.canhcam-suppport2-1 textarea').attr('rows', 5)

	// $('.canhcam-about-5 .c-accordion__list')
	$('.canhcam-suppport2-1 .list-detail .item .lead').hide();
	// $('.canhcam-suppport2-1 .list-detail .content ').trigger('click');
	$('.canhcam-suppport2-1 .list-detail .content ').click(function() {
		if($(this).next().is(':hidden') === true){
			$('.canhcam-suppport2-1 .list-detail .lead').slideUp('fast');
			$('.canhcam-suppport2-1 .list-detail .content ').removeClass('active');
			$(this).next().slideDown('fast');
			$(this).addClass('active');
		}else{
			$('.canhcam-suppport2-1 .list-detail .content ').removeClass('active');
			$(this).next().slideUp('fast');
		}
	});
})
$(document).ready(function(){
	$('.canhcam-suppport3-1 textarea').attr('rows', 5)
})

$(function () {
	$('.canhcam-product-detail-1 .owl-carousel').owlCarousel({
		items: 1,
		loop: true,
		center: true,
		margin: 0,
		nav: true,
		navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
		dots: false,
		// autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		callbacks: true,
		margin: 10,
		responsive: {
			992: {
				items: 1.6,
			},
			1200: {
				items: 1.8,
			}
		}
	});

});




$(document).ready(function () {
	$('.canhcam-product-detail-5 select').addClass("custom-select");
	try {
		const contactFormTextareaParent = $('.liena-contactform-textarea').parent()
		contactFormTextareaParent.append($('.canhcam-product-detail-5 .frm-btn-submit').parent().parent()[0].outerHTML)
		$('.canhcam-product-detail-5 .frm-btn-submit').parent().parent()[1].outerHTML = null
	} catch (error) {

	}
});
$(document).ready(function(){
	if ($('.canhcam-product-detail-6 .owl-carousel').length) {
		$('.canhcam-product-detail-6 .owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			center: false,
			padding: 0,
			margin: 0,
			navText: ['<i class="lnr lnr-chevron-left"></i>', '<i class="lnr lnr-chevron-right"></i>'],
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			callbacks: true,
			// mouseDrag: false,
			// touchDrag: false,
			// pullDrag: false,
			// freeDrag: false,
			margin: 30,
			responsive: {
				768: {
					items: 2,
				},
				992: {
					items: 3,
				}
			}
		});
	}

})


$(document).ready(function () {
	$('.canhcam-banner-1 .owl-carousel').owlCarousel({
		loop: false,
		margin: 0,
		nav: false,
		dots: false,
		items: 1,
		mouseDrag: false,
		touchDrag: false
	})
});

const customScrollTo = (e, offset = 0, time = 1000) => {
	$('html, body').animate({
		scrollTop: $(`.${e}`).offset().top + offset
	}, time);
}

$(document).ready(function () {
	$('.about-us-1-scroll-btn').on('click', () => {
		customScrollTo('canhcam-aboutus-2', -$('header').outerHeight(), 1000)
	})

	$('.wrap-secure.wrap-login').children().addClass('offset-sm-3')
	$('.wrap-secure.wrap-login .control-label').removeClass('col-sm-2')
	$('.wrap-secure.wrap-login .control-label').next().removeClass('col-sm-10')
	$('.wrap-secure.wrap-login .col-sm-offset-2.col-sm-10').removeClass('col-sm-10').addClass('col-sm-12')

	const loginFormButtonLoginHtml = $(".wrap-secure.wrap-login input[type='submit']").parent().html()
	$(".wrap-secure.wrap-login input[type='checkbox']").parent().append(loginFormButtonLoginHtml)
	$($(".wrap-secure.wrap-login input[type='submit']")[1]).parent().parent().html('')


	var paramTab = getParameters("tab");
	if (paramTab != '') {
		$("a[href='#" + paramTab + "']").trigger("click");
	}

});


function getParameters(name, url) {
	if (!url) url = location.href;
	name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
	var regexS = "[\\?&]" + name + "=([^&#]*)";
	var regex = new RegExp(regexS);
	var results = regex.exec(url);
	return results == null ? null : results[1];
}

$(document).ready(function() {
	$(".fancybox").fancybox({
		openEffect	: 'elastic',
		closeEffect	: 'elastic'
	});
});

$(document).ready(function () {
	$('.canhcam-aboutus-4 .owl-carousel.owl-theme.testimotional').owlCarousel({
		loop: true,
		margin: 0,
		nav: false,
		items: 1,
		dots: true
	})
});

$(document).ready(function () {
	try {
		disableUnlinkedBreadcrumb()
	} catch(error) {
		
	}
});

const disableUnlinkedBreadcrumb = () => {
	let breadcrumbElements = document.querySelectorAll('.la-product-details .breadcrumb li a')
	for (let i = 0; i < breadcrumbElements.length; i++) {
		const element = breadcrumbElements[i];
		let elementHrefLastCharacter = element.href[element.href.length - 1]
		if (elementHrefLastCharacter === '#') {
			element.parentNode.style.display = 'none'
		}
	}
}

$(document).ready(function () {
	$('.about-us2-1-scroll-btn').on('click', () => {
		customScrollTo('canhcam-aboutus2-2', -$('header').outerHeight(), 1000)
	})
});

$(document).ready(() => {
	historySlider();
	checkFullContentHistoryBox();
});

const historySlider = () => {
	$('.canhcam-aboutus2-3 .owl-carousel.owl-theme').owlCarousel({
		loop: false,
		margin: 0,
		nav: true,
		items: 1,
		navText: ["<i class='lnr lnr-chevron-left'></i>", "<i class='lnr lnr-chevron-right'></i>"],
		dots: false,
		responsive: {
			768: {
				items: 2,
				margin: 10
			},
			992: {
				items: 3
			}
		}
	})
}

const toggleHistoryFullContent = (id) => {
	$(`${id} .history-box-full-content`).toggleClass('history-box-full-content-active')
	$(`${id} .history-box-viewmore`).toggleClass('history-box-viewmore-active')
}

const checkFullContentHistoryBox = () => {
	$('.canhcam-aboutus2-3 .history-box .history-box-full-content').each((i, e) => {
		if ($(e).text() === "") {
			$(e).next().css('opacity', '0')
		} else {
			$(e).next().css('opacity', '1')
		}
	})
}


$(document).ready(function () {
	objectFitImages();
	$('.canhcam-banner-2 .owl-carousel').owlCarousel({
		loop: false,
		margin: 0,
		nav: false,
		dots: false,
		items: 1,
		mouseDrag: false,
		touchDrag: false
	})

	try {
		$('.banner2-scroll-btn').on('click', () => {
			customScrollTo('canhcam-aboutus3-1', -$('header').outerHeight(), 1000)
		})


		$('.Module-317 .banner2-scroll-btn').on('click', () => {
			customScrollTo('canhcam-aboutus4-ct-1', -$('header').outerHeight(), 1000)
		})
	} catch (error) {

	}
});








// function activeTabAbout5() {
// 	let geActive = '.canhcam-aboutus5-1 .tabs-header .tabs-active',
// 		activePos = $(geActive).position(),
// 		tabItems = $('.canhcam-aboutus5-1 .tabs-header li'),
// 		tabCurrentItem = tabItems.filter('.tabs-active'),
// 		activeTab1 = {
// 			changePos: function () {
// 				activePos = $(geActive).position();
// 			},
// 			changeTab: function () {
// 				let getTabId = $(geActive + ' a').attr('tab-aboutus5-id');
// 				console.log(getTabId)
// 				$('.canhcam-aboutus5-3 .tab').stop().fadeOut(300, function () {
// 					$(this).removeClass('tab-active');
// 				}).hide();
// 				$('.canhcam-aboutus5-3 .tab[tab-aboutus5-id=' + getTabId + ']').stop().fadeIn(300, function () {
// 					$(this).addClass('tab-active');
// 				});
// 			},
// 			doButton: function () {
// 				$('.canhcam-aboutus5-1 .tabs-header a').on('click', function (e) {
// 					e.preventDefault();
// 					let tabId = $(this).attr('tab-aboutus5-id');
// 					$('.canhcam-aboutus5-1 .tabs-header a').stop().parent().removeClass('tabs-active');
// 					$(this).stop().parent().addClass('tabs-active');
// 					activeTab1.changePos();
// 					tabCurrentItem = tabItems.filter('tabs-active');
// 					$('.canhcam-aboutus5-3 .tab').stop().fadeOut(300, function () {
// 						$(this).removeClass('tab-active');
// 					}).hide();
// 					$('.canhcam-aboutus5-3 .tab[tab-aboutus5-id="' + tabId + '"]').stop().fadeIn(300, function () {
// 						$(this).addClass('tab-active');
// 					});
// 				});
// 			}
// 		}
// 	activeTab1.changePos()
// 	activeTab1.doButton()
// }

// $(document).ready(function () {
// 	activeTabAbout5()
// });

$(document).ready(function () {
	try {
		document.querySelector('.pagination .NextPage').parentNode.style.display = 'none'
		document.querySelector('.pagination .LastPage').parentNode.style.display = 'none'

	} catch (error) {

	}

	try {
		document.querySelector('.pagination .FirstPage').parentNode.style.display = 'none'
		document.querySelector('.pagination .BackPage').parentNode.style.display = 'none'
	} catch (error) {

	}

	if ($('.row.news-wrapper').children().length <= 2) {
		$('.row.news-wrapper').addClass('less-than-2-news')
	}
});




$(document).ready(function () {
	$('.canhcam-banner-3 .owl-carousel').owlCarousel({
		loop: false,
		margin: 0,
		nav: false,
		dots: false,
		items: 1,
		mouseDrag: false,
		touchDrag: false
	})

	try {
		$('.banner3-scroll-btn').on('click', () => {
			customScrollTo('canhcam-product-1', -$('header').outerHeight(), 1000)
		})
	} catch (error) {
		
	}
});


$(document).ready(function () {
	$('.canhcam-banner-4 .owl-carousel').owlCarousel({
		loop: false,
		margin: 0,
		nav: false,
		dots: false,
		items: 1,
		mouseDrag: false,
		touchDrag: false
	})

	try {
		
		$('.latexmattress .banner4-scroll-btn').on('click', () => {
			customScrollTo('canhcam-productlist-1', -$('header').outerHeight(), 1000)
		})
		$('.spring-mouldedfoam .banner4-scroll-btn').on('click', () => {
			customScrollTo('canhcam-productlist-1', -$('header').outerHeight(), 1000)
		})

		$('.la-product-list-details .canhcam-banner-4 .banner4-scroll-btn').on('click', () => {
			customScrollTo('canhcam-product-detail-2', -$('header').outerHeight(), 1000)
		})
	} catch (error) {

	}
});





$(document).ready(() => {

});

// window.onresize = (event) => {
// 	setProductListTab();
// }

// const setProductListTab = () => {
// 	const header_outer_height = $('header').outerHeight();
// 	$('.canhcam-productlist-5').css('top', header_outer_height);
// }

// function activeTabServiceCt() {
// 	let geActive = '.canhcam-tabs-service-ct .tabs-nav .tab-active',
// 		activePos = $(geActive).position(),
// 		tabItems = $('.canhcam-tabs-service-ct .tabs-nav li'),
// 		tabCurrentItem = tabItems.filter('.active'),
// 		activeTab1 = {
// 			changePos: function () {
// 				activePos = $(geActive).position();
// 			},
// 			changeTab: function () {
// 				let getTabId = $(geActive + ' a').attr('tab-pl-id');
// 				$('.canhcam-tabs-service-ct .tab').stop().fadeOut(300, function () {
// 					$(this).removeClass('tab-active');
// 				}).hide();
// 				$('.canhcam-tabs-service-ct .tab[tab-pl-id=' + getTabId + ']').stop().fadeIn(300, function () {
// 					$(this).addClass('tab-active');
// 				});
// 			},
// 			doButton: function () {
// 				$('.canhcam-tabs-service-ct .tabs-nav a').on('click', function (e) {
// 					e.preventDefault();
// 					let tabId = $(this).attr('tab-pl-id');
// 					$('.canhcam-tabs-service-ct .tabs-nav a').stop().parent().removeClass('tabs-nav-item-active');
// 					$(this).stop().parent().addClass('tabs-nav-item-active');
// 					activeTab1.changePos();
// 					tabCurrentItem = tabItems.filter('tabs-nav-item-active');
// 					$('.canhcam-tabs-service-ct .tab').stop().fadeOut(300, function () {
// 						$(this).removeClass('tab-active');
// 					}).hide();
// 					$('.canhcam-tabs-service-ct .tab[tab-pl-id="' + tabId + '"]').stop().fadeIn(300, function () {
// 						$(this).addClass('tab-active');
// 						$('.toggle').click()
// 					});
// 				});
// 			}
// 		}
// 	activeTab1.changePos()
// 	activeTab1.doButton()
// }

function activeTabProductListHeader() {
	let geActive = '.canhcam-productlist-5 .tabs-header .tabs-active',
		activePos = $(geActive).position(),
		tabItems = $('.canhcam-productlist-5 .tabs-header li'),
		tabCurrentItem = tabItems.filter('.tabs-active'),
		activeTab1 = {
			changePos: function () {
				activePos = $(geActive).position();
			},
			changeTab: function () {
				let getTabId = $(geActive + ' a').attr('tab-pl-id');
				console.log(getTabId)
				$('.canhcam-productlist-6 .tab').stop().fadeOut(300, function () {
					$(this).removeClass('tab-active');
				}).hide();
				$('.canhcam-productlist-6 .tab[tab-pl-id=' + getTabId + ']').stop().fadeIn(300, function () {
					$(this).addClass('tab-active');
				});
			},
			doButton: function () {
				$('.canhcam-productlist-5 .tabs-header a').on('click', function (e) {
					e.preventDefault();
					let tabId = $(this).attr('tab-pl-id');
					$('.canhcam-productlist-5 .tabs-header a').stop().parent().removeClass('tabs-active');
					$(this).stop().parent().addClass('tabs-active');
					activeTab1.changePos();
					tabCurrentItem = tabItems.filter('tabs-active');
					$('.canhcam-productlist-6 .tab').stop().fadeOut(300, function () {
						$(this).removeClass('tab-active');
					}).hide();
					$('.canhcam-productlist-6 .tab[tab-pl-id="' + tabId + '"]').stop().fadeIn(300, function () {
						$(this).addClass('tab-active');
					});
				});
			}
		}
	activeTab1.changePos()
	activeTab1.doButton()
}

$(document).ready(function () {
	activeTabProductListHeader()
});

